const intitState = {
  authError: null,
  step: 0,
  visible: false,
  loading: false,
  itemIndex: null,
  otherUserProfile: {},
  userSolvedProblems: {},
  skills: {},
  projects: {},
  teams:{},
  campusDashboardData: {},
  assessmentProfileData: {},
  faculty: {},
  studentList: {},
  hodList: {}
};

const authReducer = (state = intitState, action) => {
  // 
  // 
  switch (action.type) {
    case "HOME_PAGE_UNLOADED":
      return intitState;
    case "LOGIN_ERROR":
      // 
      return {
        ...state,
        authError: "Login failed"
      };
    case "LOGIN_SUCCESS":
      // 
      return {
        ...state,
        authError: null,
        step: action.payload.step,
        visible: false,
        loading: false
      };
    case "CHANGE_STEP":
      // 
      return {
        ...state,
        step: action.payload.step,
        visible: false,
        loading: false
      };
    case "HIDE_MODEL_FROM_STEP":
      // 
      return {
        ...state,
        visible: action.payload.visible,
        loading: action.payload.loading,
        step: action.payload.step,
        itemIndex: action.payload.itemIndex
      };
    case "LOAD__USER_PROFILE_DATA":
      return {
        ...state,
        userProfile: action.payload
      };
    case "LOAD_SOLVED_PROBLEM":
      return {
        ...state,
        userSolvedProblems: action.payload
      };
    case "LOAD_SKILL":
      return {
        ...state,
        skills: action.payload
      };
    case "LOAD_PROJECT_LIST":
      return {
        ...state,
        projects: action.payload
      };
      case "LOAD_TEAM_LIST":
      return {
        ...state,
        teams: action.payload
      };
    case "LOAD_FACULTY_LIST":
      return {
        ...state,
        faculty: action.payload
      };
    case "LOAD_HOD_LIST":
      return {
        ...state,
        hodList: action.payload
      };
    case "LOAD_CAMPUS_DASHBOARD_DATA":
      return {
        ...state,
        campusDashboardData: action.payload
      };
    case "LOAD_assessment_PROFILE_DATA":
      return {
        ...state,
        assessmentProfileData: action.payload
      };
    case "LOAD_ALL_STUDENTS":
      return {
        ...state,
        studentList: action.payload
      };
      case "LOAD_CP_LEADERBOARD":
      return {
        ...state,
        cpLeaderBoardList: action.payload
      };
    case "LOAD_ALL_TEAMS":
      return {
        ...state,
        teams: action.payload
      };
    default:
      return state;
  }
};

export default authReducer;
